import { render, staticRenderFns } from "./OnboardingAvatar.vue?vue&type=template&id=2f9dd3f2&scoped=true&"
import script from "./OnboardingAvatar.vue?vue&type=script&lang=js&"
export * from "./OnboardingAvatar.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAvatar.vue?vue&type=style&index=0&id=2f9dd3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9dd3f2",
  null
  
)

export default component.exports